import Card from "../../../components/Card";
import { LoanTenureText } from "./RecomendedLoanSection";
import ChatIcon from "../../../assets/Icons/ChatIcon";
import { Button } from "../../../components/Buttons";
import TextWithIcon from "../../../components/TextWithIcon";

export default function PersonalLoanListCard() {
  return (<>
    <Card className="mt-[120px]">
      <div className="grid grid-cols-5 gap-[12px]">
        <div className="col-span-4 md:col-span-2">
          <p className="font-Apparat font-[700] text-[16px] md:text-[24px] leading-[20px] md:leading-[32px] tracking-[-2%]">Personal Loan</p>
          <div className="flex gap-[12px]">
            <div>
              <p className="font-Apparat font-[500] md:font-[600] text-[12px] md:text-[16px] leading-[12px] md:leading-[18.56px] tracking-[-2%] text-[#42495280] mt-[4px]">Emi due on</p>
              <p className="font-Apparat font-[600] md:text-[16px] md:leading-[18.56px] text-[12px] leading-[16px] tracking-[-2%] text-[#07B9AE] mt-[2px]">Feb 5,2024</p>
            </div>
            <div className="block md:hidden">
              <p className="font-Apparat font-[500] md:font-[600] text-[12px] md:text-[16px] leading-[12px] md:leading-[18.56px] tracking-[-2%] text-[#42495280] mt-[4px]">Emi Paid</p>
              <p className="font-Apparat font-[600] md:text-[16px] md:leading-[18.56px]
          text-[12px] leading-[16px] tracking-[-2%] text-[#07B9AE] mt-[2px]">1/3</p>
            </div>
          </div>
        </div>
        <div className="col-span-1 flex md:hidden items-start justify-end">
          <TextWithIcon Icon={ChatIcon} text="Support" />
        </div>
        <div className="col-span-1 text-end hidden md:block"> <LoanTenureText title="Total loan amount" value={`₹ 5000`} /></div>
        <div className="col-span-1 text-end hidden md:block">
          <LoanTenureText title="Tenure" value={`6 Mon`} /></div>
        <div className="col-span-1 text-end hidden md:block"><LoanTenureText title="EMI Every Month" value={`₹ 5000`} /></div>

        <div className="col-span-3 hidden md:block">
          <p className="font-Apparat font-[600] text-[16px] leading-[18.56px] tracking-[-2%] text-[#42495280]">Loan taken on 03/04/23</p>
          <div className="flex">
            <div class="bg-[#07B9AE1A] py-[8px] px-[24px] rounded-[25px]  flex items-end mt-[8px]">
              <p className="bg-[#07B9AE] h-[8px] w-[8px] rounded-full mb-[4px] me-[4px]"></p>
              <span class="font-[600] text-[#07B9AE] text-[14px] leading-[16.24px] tracking-[-2%]"> Active Loan</span>
            </div>
          </div>
        </div>
        <div className="col-span-1 text-end hidden md:block">
          <div>
            <p className="font-Apparat font-[600] text-[16px] leading-[18.56px] tracking-[-2%] text-[#07B9AE] mt-[2px]">EMI Paid- 1/3</p>
            <p className="font-filson-soft font-[700] mt-[8px] text-[24px] leading-[27.5px] tracking-[-2%]">
              Rs 2000
            </p>
          </div>
        </div>
        <div className="col-span-1  text-end hidden md:block">
          <div>
            <LoanTenureText title="Balance" value={`₹ 5000`} />
          </div>
        </div>
        <div className="col-span-2 flex items-end md:hidden ">
          <p className="font-filson-soft font-[700] text-[16px] leading-[18.56px]">₹ 5000</p>
        </div>
        <div className="col-span-3 md:col-span-5 flex justify-end items-end gap-[8px]">
          <TextWithIcon Icon={ChatIcon} text="Support" className="!items-end hidden md:block" />
          <Button title={"Pay"} />
        </div>
      </div>
    </Card>
  </>)
}